export default __webpack_public_path__ + "static/media/photo--lg--hockey3.1d673ac7.jpg";